(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .config(config);

  // @ngInject
  function config($stateProvider) {

    $stateProvider
        .state('executiveSummary', {
          abstract: true,
          parent : 'storePage',
          url : '/executive-summary',
          template : '<ui-view autoscroll="true"></ui-view>'
        })
        .state('executiveSummary.summary', {
          url : '/summary',
          data: {
            auth : { privilege : 'report.ExecutiveSummary' },
            title:'Executive Summary',
            path:'executiveSummary/summary'
          },
          templateUrl : 'StandardReports/ExecutiveSummary/ExecutiveSummary.tmpl.html',
          controller : 'ExecutiveSummaryCtrl as vm'
        });
  }

})();